export var KEY_CODES = { ESCAPE_KEY: 27 };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/internal/constants.js
// module id = 65
// module chunks = 0